import {
  IMauEmail,
  IMauEmailBien,
  IMauEmailGuiRequest,
  IMauEmailGuiResult,
  IMauEmailLichSuRequest,
  IMauEmailLichSuResult,
  IMauEmailLocRequest,
  IMauEmailLocResult,
  IMauEmailSaveRequest,
  IMauEmailSelectRequest,
  IMauEmailTieuChi,
  IMauEmailXemTruoc,
} from "../../../api/thiet-lap/mauEmailApi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eMauEmailActionsObj = {
  // ===== MẪU EMAIL =====
  MAU_CHANGE_REQUEST: {} as Partial<IMauEmailSelectRequest>,
  MAU_LOAD_START: {} as IMauEmailSelectRequest,
  MAU_LOAD_SUCCESS: [] as IMauEmail[],
  MAU_LOAD_ERROR: "",

  /** undefined = thêm mới; có mẫu = sửa mẫu đó. */
  MAU_SHOW_MODAL: {} as IMauEmail | undefined,
  MAU_CLOSE_MODAL: undefined,

  MAU_SAVE_START: {} as IMauEmailSaveRequest,
  MAU_SAVE_SUCCESS: "",
  MAU_SAVE_ERROR: "",

  MAU_DELETE_START: 0,
  MAU_DELETE_SUCCESS: "",
  MAU_DELETE_ERROR: "",

  /** Danh sách chỗ điền dùng được trong mẫu (máy chủ khai). */
  BIEN_LOAD_START: undefined,
  BIEN_LOAD_SUCCESS: [] as IMauEmailBien[],
  BIEN_LOAD_ERROR: "",

  /** Đã khai máy chủ gửi email chưa. */
  SMTP_LOAD_START: undefined,
  SMTP_LOAD_SUCCESS: false,

  // ===== GỬI =====
  /** Chọn mẫu ở màn gửi: nạp tiêu chí + tiêu đề + nội dung + tham số của mẫu. */
  CHON_MAU: {} as IMauEmail | undefined,
  CHANGE_TIEU_CHI: {} as Partial<IMauEmailTieuChi>,
  CHANGE_NOI_DUNG: {} as { tieu_de?: string; noi_dung?: string },
  CHANGE_THAM_SO_VALUE: {} as { ma: string; gia_tri: string },

  LOC_START: {} as IMauEmailLocRequest,
  LOC_SUCCESS: {} as IMauEmailLocResult,
  LOC_ERROR: "",

  SELECTED_SV: [] as string[],

  GUI_START: {} as IMauEmailGuiRequest,
  GUI_SUCCESS: {} as IMauEmailGuiResult,
  GUI_ERROR: "",

  XEM_TRUOC_START: {} as IMauEmailGuiRequest,
  XEM_TRUOC_SUCCESS: {} as IMauEmailXemTruoc,
  XEM_TRUOC_ERROR: "",
  DONG_XEM_TRUOC: undefined,

  // ===== LỊCH SỬ =====
  LICHSU_CHANGE_REQUEST: {} as Partial<IMauEmailLichSuRequest>,
  LICHSU_LOAD_START: {} as IMauEmailLichSuRequest,
  LICHSU_LOAD_SUCCESS: {} as IMauEmailLichSuResult,
  LICHSU_LOAD_ERROR: "",
};

export const eMauEmailActionIds = generateActionTypeIds(
  eMauEmailActionsObj,
  "MAU_EMAIL",
);

export type IMauEmailActionTypes = IGenericActionType<
  typeof eMauEmailActionsObj,
  "MAU_EMAIL"
>;
